export const questions = [
 "How would you rate your quiz experience with us?"
    ,
 "I find this product helpful for my cognitive abilities."
    ,
 "Quizup is easy to use."
    ,
    
 "How would you rate our product design?"
    ,
 "How likely are you to recommend Quizup to a friend or colleague?"
    ,
]

